import { useState } from "react";

/* COMPONENTS */
import DatePicker from "react-datepicker";

/* PHILIPPINE LOCATIONS */
import useLocationData from "../../../../hooks/useLocationData";

/* CSS */
import '../../../../styles/stepper.css'


const Page3 = ({ formData,setFormData, nextPage, prevPage }) => {

  const [regions, setRegions] = useState([]);
  


  const { provinces, cityMunicipalities, barangays, loadingProvinces,loadingCities,loadingBarangays, setProvinces, setCityMunicipalities, setBarangays } = useLocationData(formData);

  const [errors, setErrors] = useState({});
  const validate = () => {
    const newErrors = {};
  
    const fields = [
      'firstName',
      // 'middleName',
      'lastName',
      'birthday',
      'gender',
      'country',
      'region',
      'province',
      'cityMunicipality',
      'barangay',
      ...(formData.secondPartyFirstName ? [
        'secondPartyFirstName',
        'secondPartyLastName',
        'secondPartyBirthday',
        'secondPartyGender'
      ] : [])
    ];

   
    const formatFieldName = (field) => {
      return field
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // Split camelCase (e.g., "firstName" -> "First name")
        .replace(/^./, (str) => str.toUpperCase());  // Capitalize the first letter
    };
  
    // Loop through the fields and check if they're empty
    fields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${formatFieldName(field)} is required.`; // Dynamic error message
      }
    });
  
    // Update state with errors
    setErrors(newErrors);


    // Scroll to the first invalid element
    setTimeout(() => {
    const firstInvalidElement = document.querySelector('.invalid-feedback');
      if (firstInvalidElement) {
        firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalidElement.focus?.();
      }
    }, 0);
  
    // Return true if no errors, false otherwise
    return Object.keys(newErrors).length === 0;
  };
  

  const handleNext = () => {
    if (validate()) {
      nextPage();
    }
  };
 


// Handle changes to each dropdown
const handleRegionChange = (event) => {
  setFormData((prev) => ({ ...prev, province: "" }));
  setFormData((prev) => ({ ...prev, cityMunicipality:""}));
  setFormData((prev) => ({ ...prev, barangay:""}));

  setFormData((prev) => ({ ...prev, region: event.target.value }));
};

const handleProvinceChange = (event) => {
  setFormData((prev) => ({ ...prev, cityMunicipality:""}));
  setFormData((prev) => ({ ...prev, barangay:""}));
  setFormData((prev) => ({ ...prev, province: event.target.value }));
};

const handleCityMunicipalityChange = (event) => {
  setFormData((prev) => ({ ...prev, barangay:""}));
  setFormData((prev) => ({ ...prev, cityMunicipality: event.target.value }));
};

const handleBarangayChange = (event) => {
  setFormData((prev) => ({ ...prev, barangay: event.target.value }));
};

const handleDateChange = (date,key) => {
  setFormData({
    ...formData,
    [key]: date ? date : "",
  });
};





  // console.log(phil.regions);

  // const data = useFetchLocations(`${process.env.REACT_APP_API_URL}/locations/`);
  // useEffect(() => {
  //   console.log("Data fetched:", data);
  // }, [data]);

  
 

  
  return (
    <div className="step-content">
      <div className="row mb-4">
        {/* 1ST PARTY INFO */}
        <div className="col-md-6">

          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex flex-column justify-content-center">
              <h5 className="mb-1">1sty Party Information</h5>
              <p className="mb-1"><span className="fw-medium">Enter 1st party info.</span></p>
            </div>
          </div>


          <div className="row">

            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="txtFirstName" >
                First Name
              </label>
              <input
                type="text"
                className={`form-control mt-n1 ${!formData.firstName && errors.firstName && 'is-invalid'}`}
                id="txtFirstName"
                value={formData.firstName}
                name="first_name"
                placeholder="Enter First Name"
                aria-label="First Name"
                onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
              />
              {!formData.firstName && errors.firstName && <div className="invalid-feedback d-block blink">{errors.firstName}</div>}

            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="txtMiddleName" >
                Middle Name <span className="text-danger"></span>
              </label>
              <input
                type="text"
                className={`form-control mt-n1 ${!formData.middleName && errors.middleName && 'is-invalid'}`}
                id="txtMiddleName"
                value={formData.middleName}
                name="middle_name"
                placeholder="Enter Middle Name"
                aria-label="Middle Name"
                onChange={(e) => setFormData({ ...formData, middleName: e.target.value })}
              />
              {!formData.middleName && errors.middleName && <div className="invalid-feedback d-block blink">{errors.middleName}</div>}

            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="txtLastName" >
                Last Name
              </label>
              <input
                type="text"
                className={`form-control mt-n1 ${!formData.lastName && errors.lastName && 'is-invalid'}`}
                id="txtLastName"
                value={formData.lastName}
                name="last_name"
                placeholder="Enter Last Name"
                aria-label="Last Name"
                onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
              />
              {!formData.lastName && errors.lastName && <div className="invalid-feedback d-block blink">{errors.lastName}</div>}

            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="txtSuffixName" >
                Suffix <span className="text-danger">( Optional )</span>
              </label>
              <input
                type="text"
                className={`form-control mt-n1 ${!formData.suffix && errors.suffix && 'is-invalid'}`}
                id="txtSuffixName"
                value={formData.suffix}
                name="last_name"
                placeholder="Example: Jr, Sr"
                aria-label="Suffix"
                onChange={(e) => setFormData({ ...formData, suffix: e.target.value })}
              />
              {!formData.suffix && errors.suffix && <div className="invalid-feedback d-block blink">{errors.suffix}</div>}
            </div>

          </div>

          <div className="col-md-12 mb-2">
            <label className="form-label text-info d-block " htmlFor="txtMiddleName" >
              Date of Birth
            </label>

            <DatePicker
              id="txtBirthday"
              name="birth_date"
              className={`form-control flatpickr-input active w-100 mt-n1 ${!formData.birthday && errors.birthday && 'is-invalid'}`}
              placeholderText="YYYY-MM-DD"

              selected={formData.birthday}
              // onChange={(e) => setFormData({ ...formData, birthday: e.target.value })}
              // onChange={handleDateChange}
              onChange={(date)=>handleDateChange(date,"birthday")}

              dateFormat="yyyy-MM-dd"
            />
            {!formData.birthday && errors.birthday && <div className="invalid-feedback d-block blink">{errors.birthday}</div>}

          </div>

          <div className="col-md-12 mb-2">
            <label className="form-label text-info mb-1" htmlFor="sel_gender" >
              Gender
            </label>

            <select
              id="sel_gender"
              className={`select2 form-select ${!formData.gender && errors.gender && 'is-invalid'}`}
              data-placeholder="Select Gender"
              value={formData.gender}
              name="cert_type"
              onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
            >
              <option value="">Gender</option>
              <option value="MALE">Male</option>
              <option value="FEMALE">Female</option>
            </select>
            {!formData.gender && errors.gender && <div className="invalid-feedback d-block blink">{errors.gender}</div>}
          </div>
        </div>


        {/* 2ND PARTY INFO */}
        {formData.secondPartyIdType && 
          <div className="col-md-6 mb-4">

            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex flex-column justify-content-center">
                <h5 className="mb-1">2nd Party Information</h5>
                <p className="mb-1"><span className="fw-medium">Enter 2nd party info.</span></p>
              </div>
            </div>


            <div className="row">

              <div className="col-md-6 mb-2">
                <label className="form-label text-info" htmlFor="secondPartyTxtFirstName" >
                  First Name
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.secondPartyFirstName && errors.secondPartyFirstName && 'is-invalid'}`}
                  id="secondPartyTxtFirstName"
                  value={formData.secondPartyFirstName}
                  name="second_party_first_name"
                  placeholder="Enter First Name"
                  aria-label="First Name"
                  onChange={(e) => setFormData({ ...formData, secondPartyFirstName: e.target.value })}
                />
                {!formData.secondPartyFirstName && errors.secondPartyFirstName && <div className="invalid-feedback d-block blink">{errors.secondPartyFirstName}</div>}

              </div>

              <div className="col-md-6 mb-2">
                <label className="form-label text-info" htmlFor="secondPartyTxtMiddleName" >
                  Middle Name <span className="text-danger"></span>
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.secondPartyMiddleName && errors.secondPartyMiddleName && 'is-invalid'}`}
                  id="secondPartyTxtMiddleName"
                  value={formData.secondPartyMiddleName}
                  name="second_party_middle_name"
                  placeholder="Enter Middle Name"
                  aria-label="Middle Name"
                  onChange={(e) => setFormData({ ...formData, secondPartyMiddleName: e.target.value })}
                />
                {!formData.secondPartyMiddleName && errors.secondPartyMiddleName && <div className="invalid-feedback d-block blink">{errors.secondPartyMiddleName}</div>}

              </div>

              <div className="col-md-6 mb-2">
                <label className="form-label text-info" htmlFor="secondPartyTxtLastName" >
                  Last Name
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.secondPartyLastName && errors.secondPartyLastName && 'is-invalid'}`}
                  id="secondPartyTxtLastName"
                  value={formData.secondPartyLastName}
                  name="second_party_last_name"
                  placeholder="Enter Last Name"
                  aria-label="Last Name"
                  onChange={(e) => setFormData({ ...formData, secondPartyLastName: e.target.value })}
                />
                {!formData.secondPartyLastName && errors.secondPartyLastName && <div className="invalid-feedback d-block blink">{errors.secondPartyLastName}</div>}

              </div>

              <div className="col-md-6 mb-2">
                <label className="form-label text-info" htmlFor="secondPartyTxtSuffixName" >
                  Suffix <span className="text-danger">( Optional )</span>
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.secondPartySuffix && errors.secondPartySuffix && 'is-invalid'}`}
                  id="secondPartyTxtSuffixName"
                  value={formData.secondPartySuffix}
                  name="second_party_suffix"
                  placeholder="Example: Jr, Sr"
                  aria-label="Suffix"
                  onChange={(e) => setFormData({ ...formData, secondPartySuffix: e.target.value })}
                />
                {!formData.secondPartySuffix && errors.secondPartySuffix && <div className="invalid-feedback d-block blink">{errors.secondPartySuffix}</div>}
              </div>

            </div>


            <div className="col-md-12 mb-2">
              <label className="form-label text-info d-block " htmlFor="secondPartyTxtBirthday" >
                Date of Birth
              </label>

              <DatePicker
                id="secondPartyTxtBirthday"
                name="second_party_birth_date"
                className={`form-control flatpickr-input active w-100 mt-n1 ${!formData.secondPartyBirthday && errors.secondPartyBirthday && 'is-invalid'}`}
                placeholderText="YYYY-MM-DD"

                selected={formData.secondPartyBirthday}
                onChange={(date)=>handleDateChange(date,"secondPartyBirthday")}

                dateFormat="yyyy-MM-dd"
              />
              {!formData.secondPartyBirthday && errors.secondPartyBirthday && <div className="invalid-feedback d-block blink">{errors.secondPartyBirthday}</div>}

            </div>



            <div className="col-md-12 mb-2">
              <label className="form-label text-info mb-1" htmlFor="sel_second_party_gender" >
                Gender
              </label>

              <select
                id="sel_second_party_gender"
                className={`select2 form-select ${!formData.secondPartyGender && errors.secondPartyGender && 'is-invalid'}`}
                data-placeholder="Select Gender"
                value={formData.secondPartyGender}
                name="sel_second_party_gender"
                onChange={(e) => setFormData({ ...formData, secondPartyGender: e.target.value })}
              >
                <option value="">Gender</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
              </select>
              {!formData.secondPartyGender && errors.secondPartyGender && <div className="invalid-feedback d-block blink">{errors.secondPartyGender}</div>}
            </div>
          </div>
        }


        {/* PRESENT ADDRESS */}
        <div className="col-md-6">

          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex flex-column justify-content-center">
              <h5 className="mb-1">Address Information</h5>
              <p className="mb-1"><span className="fw-medium">Enter present address.</span></p>
            </div>
          </div>
          <div className="row">
            {/* COUNTRY */}
            <div className="col-md-6 mb-2">
              <label className="form-label text-info" htmlFor="txtCountry" >
                Country
              </label>
              <input
                type="text"
                className={`form-control mt-n1 ${!formData.country && errors.country && 'is-invalid'}`}
                id="txtCountry"
                value={formData.country ?? "Philippines"}
                name="country"
                placeholder="Enter Country"
                aria-label="Country"
                onChange={(e) => setFormData({ ...formData, country: e.target.value })}

              />
            </div>

            {/* REGION */}
            <div className="col-md-6 mb-2">
              <label className="form-label text-info mb-1" htmlFor="sel_region" >
                Region
              </label>

              <select
                id="sel_region"
                className={`select2 form-select ${!formData.region && errors.region && 'is-invalid'}`}
                data-placeholder="Select Region"
                value={formData.region}
                name="region"
                onChange={handleRegionChange}
              >
                <option value="">Region</option>

                <option value="NATIONAL CAPITAL REGION (NCR)">NATIONAL CAPITAL REGION (NCR)</option>
                <option value="CORDILLERA ADMINISTRATIVE REGION (CAR)">CORDILLERA ADMINISTRATIVE REGION (CAR)</option>
                <option value="REGION I (ILOCOS REGION)">REGION I (ILOCOS REGION)</option>
                <option value="REGION II (CAGAYAN VALLEY)">REGION II (CAGAYAN VALLEY)</option>
                <option value="REGION III (CENTRAL LUZON)">REGION III (CENTRAL LUZON)</option>
                <option value="REGION IV-A (CALABARZON)">REGION IV-A (CALABARZON)</option>
                <option value="REGION IV-B (MIMAROPA)">REGION IV-B (MIMAROPA)</option>
                <option value="REGION V (BICOL REGION)">REGION V (BICOL REGION)</option>
                <option value="REGION VI (WESTERN VISAYAS)">REGION VI (WESTERN VISAYAS)</option>
                <option value="REGION VII (CENTRAL VISAYAS)">REGION VII (CENTRAL VISAYAS)</option>
                <option value="REGION VIII (EASTERN VISAYAS)">REGION VIII (EASTERN VISAYAS)</option>
                <option value="REGION IX (ZAMBOANGA PENINSULA)">REGION IX (ZAMBOANGA PENINSULA)</option>
                <option value="REGION X (NORTHERN MINDANAO)">REGION X (NORTHERN MINDANAO)</option>
                <option value="REGION XI (DAVAO REGION)">REGION XI (DAVAO REGION)</option>
                <option value="REGION XII (SOCCSKSARGEN)">REGION XII (SOCCSKSARGEN)</option>
                <option value="REGION XIII (Caraga)">REGION XIII (Caraga)</option>
                <option value="AUTONOMOUS REGION IN MUSLIM MINDANAO (ARMM)">AUTONOMOUS REGION IN MUSLIM MINDANAO (ARMM)</option>

              </select>
              {!formData.region && errors.region && <div className="invalid-feedback d-block blink">{errors.region}</div>}
            </div>

            {/* PROVINCE */}
            <div className="col-md-6 mb-2">
              <label className="form-label text-info mb-1" htmlFor="sel_province" >
                Province
              </label>

              <select
                id="sel_province"
                className={`select2 form-select ${!formData.province && errors.province && 'is-invalid'}`}
                data-placeholder="Select Province"
                value={formData.province}
                name="province"
                onChange={handleProvinceChange}
                disabled={loadingProvinces}
              >


                {loadingProvinces ? (
                  <option value="" disabled selected>
                    <span className="spinner"></span> Loading...
                  </option>
                ) : (
                  <>
                    <option value="">Select Province</option>
                    {
                      provinces.map((prov, index) => (
                        <option key={index} value={prov.province}>
                          {prov.province}
                        </option>
                      ))
                    }
                  </>
                )}

              </select>
              {!formData.province && errors.province && <div className="invalid-feedback d-block blink">{errors.province}</div>}
            </div>

            {/* CITY/MUNICIPALITY */}
            <div className="col-md-6 mb-2">
              <label className="form-label text-info mb-1" htmlFor="sel_city" >
                City/Municipality
              </label>

              <select
                id="sel_city"
                className={`select2 form-select ${!formData.cityMunicipality && errors.cityMunicipality && 'is-invalid'}`}
                data-placeholder="Select City/Municipality"
                value={formData.cityMunicipality}
                name="city"
                onChange={handleCityMunicipalityChange}
                disabled={loadingCities}
              >

                {loadingCities ? (
                  <option value="" disabled selected>
                    <span className="spinner"></span> Loading...
                  </option>
                ) : (
                  <>
                    <option value="">Select City / Municipality</option>
                    {cityMunicipalities.map((city, index) => (
                      <option key={index} value={city.city_municipality}>
                        {city.city_municipality}
                      </option>
                    ))}
                  </>
                )}


              </select>
              {!formData.cityMunicipality && errors.cityMunicipality && <div className="invalid-feedback d-block blink">{errors.cityMunicipality}</div>}
            </div>

            {/* BARANGAY */}
            <div className="col-md-12">
              <label className="form-label text-info mb-1" htmlFor="sel_barangay" >
                Barangay
              </label>

              <select
                id="sel_barangay"
                className={`select2 form-select ${!formData.barangay && errors.barangay && 'is-invalid'}`}
                data-placeholder="Select Barangay"
                value={formData.barangay}
                name="barangay"
                onChange={handleBarangayChange}
                disabled={loadingBarangays}
              >
                {loadingBarangays ? (
                  <option value="" disabled selected>
                    <span className="spinner"></span> Loading...
                  </option>
                ) : (
                  <>
                    <option value="">Select Barangay</option>
                    {barangays.map((brgy, index) => (
                      <option key={index} value={brgy.barangay}>
                        {brgy.barangay}
                      </option>
                    ))}
                  </>
                )
                }
              </select>
              {!formData.barangay && errors.barangay && <div className="invalid-feedback d-block blink">{errors.barangay}</div>}
            </div>
          </div>
        </div>

          {/* CONTACT INFO */}
        <div className="col-md-6">

          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex flex-column justify-content-center">
              <h5 className="mb-1">Contact Information</h5>
              <p className="mb-1"><span className="fw-medium">Enter Contact Info for receiving your email certificate.</span></p>
            </div>
          </div>

          <div className="col-md-12">
            <label className="form-label text-info" htmlFor="txtContactNumber" >
              Contact Number
            </label>
            <input
              type="text"
              className={`form-control mt-n1 ${!formData.contactNumber && errors.contactNumber && 'is-invalid'}`}
              id="txtContactNumber"
              value={formData.contactNumber}
              name="contact_number"
              placeholder="Enter Contact Number"
              aria-label="Contact Number"
              onChange={(e) => setFormData({ ...formData, contactNumber: e.target.value })}
            />
          </div>

          <div className="col-md-12">
            <label className="form-label text-info" htmlFor="txtEmail" >
              Email Address
            </label>
            <input
              type="text"
              className={`form-control mt-n1 ${!formData.email && errors.email && 'is-invalid'}`}
              id="txtEmail"
              value={formData.email}
              name="middle_name"
              placeholder="Enter Email Address"
              aria-label="Email Address"
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
          </div>

        </div>

      </div>

    

      


        <div className="col-12 d-flex justify-content-between">
          <button className="btn btn-label-secondary btn-prev" onClick={prevPage}>
            <i className="bx bx-chevron-left bx-sm ms-sm-n2" />
            <span className="align-middle d-sm-inline-block d-none">
              Previous
            </span>
          </button>
          <button className="btn btn-primary btn-next" onClick={handleNext}>
            <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
              Next
            </span>
            <i className="bx bx-chevron-right bx-sm me-sm-n2" />
          </button>
        </div>
 
    </div>
  );
};

export default Page3;
